import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const ProductTabPC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;
    const handleNavigation = (route) => {
        navigate(route);
    };
    return (
        <div>
            <nav className="funeral-methods-content-navigation">
                <div className="funeral-methods-content-nav-container">
                    <ul>
                        <li><a href="#" className={`${pathname === '/mutual-assistance-product-info' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/mutual-assistance-product-info'); }}>상품안내</a></li>
                        <li><a href="#" className={`${pathname === '/service-advantages' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/service-advantages'); }}>서비스 장점</a></li>
                        <li><a href="#" className={`${pathname === '/event-procedure' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); handleNavigation('/event-procedure'); }}>행사절차</a></li>
                    </ul>
                </div>
            </nav>
        </div>
    )
}

export default ProductTabPC